import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { isNavigationFailure } from 'vue-router';

Bugsnag.start({
  apiKey: window.envVars.VUE_APP_BUGSNAG_API_KEY,
  releaseStage: window.envVars.VUE_APP_APP_MODE,
  notifyReleaseStages: ['staging', 'production'],
  plugins: [new BugsnagPluginVue()],
  autoTrackSessions: process.env.NODE_ENV === 'production',
  onError: event => {
    const errorMessage = event.errors[0]?.errorMessage || '';
    const status = event.originalError?.response?.status;

    /*
     * Ignore ResizeObserver loop errors:
     * These are browser-level warnings triggered by the embedded HubSpot support form
     * on the dashboard. The form causes continuous ResizeObserver loop warnings until
     * the user refreshes the page. This is not an application bug, has no user impact,
     * and cannot be fixed in our code.
     */
    if (errorMessage.includes('ResizeObserver loop')) {
      return false;
    }

    /*
     * Ignore 401 Unauthorized errors:
     * These are caused by expired user sessions or tokens (e.g., user left a tab open for a long time).
     * They are expected, not application bugs. Real unauthorized access is blocked by Auth0 before
     * requests reach our backend, so no security issues are filtered here.
     */
    if (status === 401) {
      return false;
    }

    /*
     * Ignore expected Vue Router NavigationFailure rejections.
     * These are expected router control-flow outcomes, not application crashes.
     * Bugsnag reports them as "unhandledrejection handler received a non-error" with no useful stack trace.
     */
    if (isNavigationFailure(event.originalError)) {
      return false;
    }
  },
});

export default Bugsnag;
